// User-related util functions
import store from'store';export var getFacilityDetails=function getFacilityDetails(id){var _store$getState=store.getState(),facilitiesV2=_store$getState.facilitiesV2;return facilitiesV2.dropdown[id];};